<wm-de-label
  [entity]="entity"
  [for]="entity.templateCode"
  [displayOnly]="true"
  *ngIf="showLabel"
></wm-de-label>
@if(!templateForPermitForm){
<div *ngIf="!contractor">Not in list selected</div>
}@else{
<wm-common-text [data]="{ text: 'Not in list selected' }"  *ngIf="!contractor"></wm-common-text>
}
<wm-select-contractor-details
  [contractor]="contractor"
  [showClear]="false"
></wm-select-contractor-details>
